import 'jquery';
import 'Lib/font-load/font-load';
import 'Lib/touch-retina-to-html-tag/touch-retina-to-html-tag';
import 'Bem/site/img-loader/img-loader';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import { onScreen } from 'Lib/on-screen/on-screen';

const $parallax = $('.bubnovskij__parallax');
const parallaxOffset = 12;

function parallax() {
    $parallax.css({ 'transform': `translate3d(0, ${Math.round(window.pageYOffset / parallaxOffset)}px, 0)` });
}

function setHeightImg() {
    $('.bubnovskij__screen5-block2-img').height($('.bubnovskij__screen5-block2-text').height() + 150);
}

$(window).on('scroll', parallax);
$(window).on('resize', setHeightImg);
setHeightImg();

onScreen($('.bubnovskij__section'), ($el) => {
    $el.addClass('bubnovskij__section_visible');
}, 200, 200, 1.6);

svgSpriteLoader('/landing/bubnovskij/svg/sprite.svg?v=20181207');